import React from 'react';
import {Avatar} from "@mui/material";

const ProfileImage = ({imageUrl, name}) => {
    const getName = () => {
        return `${name.charAt(0)}${name.charAt(name.length - 1)}`;
    };
    return (
        <div className="profile-image">
            {imageUrl && (<Avatar alt={name} src={imageUrl}/>)}
            {name && !imageUrl && (
                <Avatar>{getName()}</Avatar>
            )}
            {!name && !imageUrl && (
                <Avatar>NA</Avatar>
            )}
        </div>
    );
};

export default ProfileImage;